// frontend/user/src/routes/files.tsx
// .pen bi8Au 页面-文件 — header 单行 topRow [segmentedSwitcher | [searchBtn, transferBtn, notifBtn]]
// 2026-06-07 改版:搜索条→图标按钮,segment 文案 文件/资源包。
// header 跨 FileBrowser(文件 + 子文件夹)/ ShareList(资源包) 共享。
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useCurrentUser } from '@dogdisk/shared'
import { useMultiSelect } from '../_lib/use-multi-select'
import { MobileScreen } from '../components/mobile-screen'
import { TabBar } from '../components/tab-bar'
import { FileBrowser } from '../components/file-browser'
import { ShareList } from '../components/share-list'
import { FilePageSegment } from '../components/file-page-segment'
import { TransferButton } from '../components/transfer-button'
import { MultiSelectHeader } from '../components/multi-select-header'

type View = 'files' | 'shares'

export function FilesPage() {
  const navigate = useNavigate()
  const { status } = useCurrentUser()
  const isAuth = status === 'authenticated'

  const [searchParams, setSearchParams] = useSearchParams()
  const raw = searchParams.get('view')
  const view: View = raw === 'shares' ? 'shares' : 'files'

  const setView = (v: View) => {
    if (v === 'files') searchParams.delete('view')
    else searchParams.set('view', 'shares')
    setSearchParams(searchParams, { replace: false })
  }

  const ms = useMultiSelect()
  // 切到资源包 tab 时退出多选
  useEffect(() => {
    if (view !== 'files') ms.exit()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view])

  return (
    <MobileScreen bg="white">
      {/* .pen vHgX7 header — padding [10,24,12,24] gap 12;PWA 顶 padding 响应 safe-area */}
      <header
        data-testid="bi8Au"
        className="flex flex-col gap-3 px-6 pb-3 pt-[max(10px,env(safe-area-inset-top))]"
      >
        {/* .pen tBewr topRow:多选模式替换为 MultiSelectHeader,否则渲染常规 segment + 图标按钮 */}
        {ms.active ? (
          <MultiSelectHeader
            count={ms.count}
            allSelected={ms.allSelected}
            onCancel={ms.exit}
            onToggleAll={ms.toggleAll}
          />
        ) : (
          <div className="flex items-center justify-between">
            <FilePageSegment value={view} onChange={setView} />
            <div className="flex items-center gap-3">
              {/* .pen oe8G7 searchBtn — 44×44 圆 灰底,点击跳 /search(k9NLf) */}
              <button
                type="button"
                data-testid="files-search-btn"
                onClick={() => navigate('/search')}
                className="flex h-11 w-11 items-center justify-center rounded-full bg-[#F6F7F8] active:bg-[#EDEEF0]"
                aria-label="搜索"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="7" />
                  <path d="M21 21l-4-4" />
                </svg>
              </button>
              <TransferButton />
              <button
                type="button"
                data-testid="files-header-notification-btn"
                onClick={() => navigate('/messages')}
                className="relative flex h-11 w-11 items-center justify-center rounded-full bg-[#F6F7F8] active:bg-[#EDEEF0]"
                aria-label="通知"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
                  <path d="M13.7 21a2 2 0 01-3.4 0" />
                </svg>
                {isAuth && (
                  <span className="absolute right-0 top-0 inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-[#FF6B6B] px-1 text-[11px] font-semibold text-white">
                    6
                  </span>
                )}
              </button>
            </div>
          </div>
        )}
      </header>

      {view === 'files' ? <FileBrowser multiSelect={ms} /> : <ShareList />}
      {!ms.active && <TabBar />}
    </MobileScreen>
  )
}
